import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Select } from "antd";
import { showConfirmDlgWidget } from 'components/ConfirmDlgWidget/showConfirmDlgWidget';
import "./TableWidget.css"

function TableWidget(props) {
    const { dataList, setDataList, onUpdateAction, onDeleteAction, } = props;
    if (dataList === undefined) return <div />
    const columns = [
        {
          title: "ID",
          align: "center",
          dataIndex: "id"
        },
        {
          title: "Yield Rule Name",
          dataIndex: "name",
          width : '400px',
          align: "center",
          sorter: {
            compare: (a, b) => a.name.localeCompare(b.name),
          },
        },
        {
          title: "Created At",
          align: "center",
          dataIndex: "add_timestamp",
          sorter: {
            compare: (a, b) => a.add_timestamp.localeCompare(b.add_timestamp),
          },
        },
        {
          title: "Updated At",
          align: "center",
          dataIndex: "update_timestamp",
          sorter: {
            compare: (a, b) => a.update_timestamp.localeCompare(b.update_timestamp),
          },
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            render: (text, record) => {

                return <div size="middle" direction={"vertical"}>
                    <a className="edit-btn"
                        onClick={() => {
                            onUpdateAction(record)
                        }}
                    >
                        Edit
                    </a>
                    <a style={{ color: "var(--redColor)", marginLeft: 20 }} className="del-btn" onClick={async () => {
                        var res = await showConfirmDlgWidget({ title: "Delete Confirmation", content: "Are you sure to delete this record?" });
                        if (res == false) return;
                        onDeleteAction(record)
                    }}>
                        Delete
                    </a>
                </div>
            },
        },
    ];
    const dataSource = dataList.map((info) => {
        return { ...info, key: info.id };
    });

    return (
        <div className="list-table">
            <Table
                pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50'] }}
                columns={columns}
                dataSource={dataSource}
            />
        </div>
    )
}

export default withRouter(TableWidget)
